import { Tooltip } from '@squareup/dex-ui';
import React, { FC, PropsWithChildren } from 'react';

interface MdxTooltipProps {
  // Fern's source uses `tip="…"` as the prop name; dex-ui's Tooltip
  // calls it `text`. Translate so authors keep the existing prop name.
  tip: string;
}

// `<Tooltip tip="…">visible text</Tooltip>` — wraps an inline span of
// text with a hover/focus tooltip. dex-ui's Tooltip names the visible
// trigger `text` and renders `children` inside the popover, so Fern's
// prop/child convention has to be inverted here.
const MdxTooltip: FC<PropsWithChildren<MdxTooltipProps>> = ({
  children,
  tip,
}) => {
  const text = React.Children.toArray(children).join('');

  return <Tooltip text={text}>{tip}</Tooltip>;
};

MdxTooltip.displayName = 'MdxTooltip';

export { MdxTooltip };
